/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamExamidLangsQueryResponse,
  GetApiV1ExamExamidLangsPathParams,
  GetApiV1ExamExamidLangsQueryParams,
  GetApiV1ExamExamidLangs401,
  GetApiV1ExamExamidLangs404,
  GetApiV1ExamExamidLangs500,
} from "../../types/examEvaluationController/GetApiV1ExamExamidLangs.ts";

function getGetApiV1ExamExamidLangsUrl(
  examId: GetApiV1ExamExamidLangsPathParams["examId"],
) {
  const res = { method: "GET", url: `/api/v1/exam/${examId}/langs` as const };
  return res;
}

/**
 * @description Retorna a lista paginada de idiomas configurados para a prova informada, com o nome do idioma em português como rótulo de exibição. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas de uma prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examId/langs}
 */
export async function getApiV1ExamExamidLangs(
  examId: GetApiV1ExamExamidLangsPathParams["examId"],
  params?: GetApiV1ExamExamidLangsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamExamidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamidLangs401
      | GetApiV1ExamExamidLangs404
      | GetApiV1ExamExamidLangs500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamidLangsUrl(examId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
